export default "__VITE_ASSET__841d406b__"